// Shared post-conference helper. Once the conference is over we tone the app
// down a lot: hide game CTAs, switch the Watch tab to Replays only, slow or
// pause every poll. Bump the date when DFTB27 starts.
//
// CONFERENCE_END_DATE is set to the day BEFORE the actual closing day so the
// tidy-up state activates as soon as the closing keynote wraps up rather than
// at midnight the day after. For DFTB27, set this to the actual last day and
// the tidy-up will kick in the morning after the conference closes.
export const CONFERENCE_END_DATE = "2026-06-23";

// Returns true once we are PAST the final conference day (inclusive).
export function isConferenceOver() {
  const today = new Date().toISOString().slice(0, 10);
  return today > CONFERENCE_END_DATE;
}
